import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  TextField,
  Typography,
} from "@mui/material";
import "react-toastify/dist/ReactToastify.css";

import {
  authButton,
  bodyContainer,
  container,
  divider,
  forgotButton,
  googleButton,
  input,
  subContainer,
  titleText,
} from "./styles";
import { colors } from "../../theme/colors";
import { ReactComponent as GoogleIcon } from "../../assets/icons/ic_google.svg";
import {
  GoogleAuthProvider,
  signInWithEmailAndPassword,
  signInWithPopup,
} from "firebase/auth";
import { auth } from "../../services/firebase";
import { useNavigate } from "react-router-dom";
import { getErrorMessage, showToast } from "../../services/toast";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [loginType, setLoginType] = useState("");
  const [isFromExisitng, setIsFromExisting] = useState<string>("");

  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: "select_account" });

  const navigate = useNavigate();

  useEffect(() => {
    let tempStep = localStorage.getItem("step");
    let dataFrom = localStorage.getItem("from");
    if (tempStep === "1") {
      if (dataFrom === "dcc") {
        setIsFromExisting("dcc");
      } else {
        setIsFromExisting("information");
      }
    }
  }, []);

  const onLogin = () => {
    if (email === "") {
      showToast("You must input email address", "error");
      return;
    }
    if (password === "") {
      showToast("You must input password", "error");
      return;
    }
    setIsLoading(true);
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        setIsLoading(false);
        // const user = userCredential.user;
        if (isFromExisitng === "information") {
          navigate("/inspection");
        } else if (isFromExisitng === "dcc") {
          navigate("/criminal");
        } else {
          navigate("/");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        const errorCode = error.code;
        const errorMessage = getErrorMessage(errorCode);
        showToast(errorMessage, "error");
      });
  };

  const onGoogleLogin = () => {
    setIsLoading(true);
    signInWithPopup(auth, provider)
      .then((result) => {
        setIsLoading(false);
        // const credential = GoogleAuthProvider.credentialFromResult(result);
        // const token = credential.accessToken;
        // const user = result.user;
        if (isFromExisitng === "information") {
          navigate("/inspection");
        } else if (isFromExisitng === "dcc") {
          navigate("/criminal");
        } else {
          navigate("/");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        const errorMessage = error.message;
        showToast(errorMessage, "error");
      });
  };

  return (
    <Box sx={(theme) => container(theme)}>
      <Box sx={(theme) => bodyContainer(theme)}>
        <Box sx={(theme) => subContainer(theme)}>
          <Typography sx={(theme) => titleText(theme)}>Welcome Back</Typography>
          <Divider sx={(theme) => divider(theme)}>continue with</Divider>
          <TextField
            placeholder="Email address"
            size="small"
            fullWidth
            type="email"
            required
            sx={(theme) => input(theme)}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            placeholder="Password"
            size="small"
            fullWidth
            type="password"
            required
            sx={(theme) => input(theme)}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            fullWidth
            variant="contained"
            sx={(theme) => authButton(theme)}
            disabled={isLoading}
            onClick={() => {
              setLoginType("email");
              onLogin();
            }}
          >
            Login
            {isLoading && loginType === "email" && (
              <CircularProgress size={20} sx={{ ml: 1 }} />
            )}
          </Button>

          <Button
            sx={(theme) => forgotButton(theme)}
            onClick={() => navigate("/forgot-password")}
          >
            Forgot password?
          </Button>

          <Button
            fullWidth
            variant="contained"
            sx={(theme) => authButton(theme)}
            disabled={isLoading}
            onClick={() => navigate("/register")}
          >
            Register
          </Button>
          <Divider sx={(theme) => divider(theme)}>continue with</Divider>
          <Button
            fullWidth
            variant="contained"
            startIcon={<GoogleIcon />}
            disabled={isLoading}
            sx={(theme) => googleButton(theme)}
            onClick={() => {
              setLoginType("google");
              onGoogleLogin();
            }}
          >
            Google
            {isLoading && loginType === "google" && (
              <CircularProgress size={20} sx={{ ml: 1 }} />
            )}
          </Button>
          <Typography
            sx={{
              textAlign: "center",
              fontSize: "12px",
              color: colors.dark_gray,
            }}
          >
            By clicking continue, you agree to our{" "}
            <b style={{ color: "black" }}>Terms of Service</b> and{" "}
            <b style={{ color: "black" }}>Privacy Policy</b>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Login;
